import isFieldVisible from "./isFieldVisible";
import { FieldSettingsMap, FieldsOfInterest } from "../../types/fieldSettings";
import isTestFieldRequired from "./getFieldRequirement";
import { TestSuite } from "../../types/test-suite";

function getFieldSettings(testSuite: Pick<TestSuite, 'type' | 'settings' | 'custom_fields'> | null) {
    if (!testSuite) return {} as Partial<FieldSettingsMap>;
  
    const fields: FieldsOfInterest[] = [
      'element',
      'element_name',
      'element_id',
      'location', // This covers building_id, level_id, area_id
      'images', // This is 'photographs' internally
    ];
  
    const settings: Partial<FieldSettingsMap> = {};
  
    fields.forEach((fieldName: keyof FieldSettingsMap) => {
      settings[fieldName] = {
        active: isFieldVisible(testSuite, fieldName),
        required: isTestFieldRequired(testSuite, fieldName)
      };
    });
  
    // console.log('🔍 FIELD SETTINGS FOR TEST SUITE:', {
    //     testSuiteType: testSuite.type,
    //     testSuiteTitle: testSuite.title,
    //     fieldSettings: settings
    // });
  
    return settings;
  }

  export default getFieldSettings;